import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { RouterService } from './core/services/router.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit {


  constructor(
    private routerService: RouterService
  ) {}

  ngOnInit(): void {
    //Getting route that is set within *.routing.ts files 
    this.routerService.setupPageTitles();

    const script = document.createElement('script');
    script.innerHTML = `
      window.markerConfig = {
        project: '686657a206a7b412645e9905', 
        source: 'snippet'
      };

      ! function(e, r, a) {
          if (!e.__Marker) {
              e.__Marker = {};
              var t = [],
                  n = {
                      __cs: t
                  };
              ["show", "hide", "isVisible", "capture", "cancelCapture", "unload", "reload", "isExtensionInstalled", "setReporter", "clearReporter", "setCustomData", "on", "off"].forEach(function(e) {
                  n[e] = function() {
                      var r = Array.prototype.slice.call(arguments);
                      r.unshift(e), t.push(r)
                  }
              }), e.Marker = n;
              var s = r.createElement("script");
              s.async = 1, s.src = "https://edge.marker.io/latest/shim.js";
              var i = r.getElementsByTagName("script")[0];
              i.parentNode.insertBefore(s, i)
          }
      }(window, document);
    `;
    document.head.appendChild(script);
  }
}
